module.exports = __webpack_public_path__ + "img/remono.c4a8cf1d.png";